// extracted by mini-css-extract-plugin
export default {"attributes":"styles_attributes__aZ33G","subHeader":"styles_subHeader__ybiRC","subHeaderHidden":"styles_subHeaderHidden__gl6Ly"};